import log from 'loglevel'
import axios from 'axios'

import Cache from '../utils/cache'

/* eslint class-methods-use-this: ["off"] */

export default class Modality {
  constructor() {
    log.info('[INFO] Initialize Modality Module')
    this.cache = new Cache()
  }

  fetchModalities(params) {
    let parameters = {}

    if (params) {
      parameters = {
        params: {
          p: params.p,
          page_size: params.page_size,
          search: params.q,
        },
      }
    }

    const result = this.cache.bind(parameters, 10, () => {
      const promise = new Promise((resolve, reject) => {
        axios
          .get('v1/bidding/modality/', parameters)
          .then(response => {
            log.debug('[DEBUG] Success to fetch modalities')
            resolve(response)
          })
          .catch(error => {
            log.error('[ERROR] Fail to fetch modalities')
            log.error(error)
            reject(error.response)
          })
      })
      return promise
    })
    return result
  }

  fetchModality(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`v1/bidding/modality/${id}/`)
        .then(response => {
          log.debug('[DEBUG] Success to fetch modality')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to fetch modality')
          log.error(error)
          reject(error.response)
        })
    })
  }

  updateModality(id, modalityData) {
    return new Promise((resolve, reject) => {
      axios
        .put(`v1/bidding/modality/${id}/`, modalityData)
        .then(response => {
          log.debug('[DEBUG] Success to update modality')
          this.cache.reset()
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to update modality')
          log.error(error)
          reject(error.response)
        })
    })
  }

  addModality(modalityData) {
    return new Promise((resolve, reject) => {
      axios
        .post('v1/bidding/modality/', modalityData)
        .then(response => {
          log.debug('[DEBUG] Success to add modality')
          this.cache.reset()
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to add modality')
          log.error(error)
          reject(error.response)
        })
    })
  }

  deleteModality(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`v1/bidding/modality/${id}/`)
        .then(() => {
          log.debug('[DEBUG] Success to delete modality')
          this.cache.reset()
          resolve()
        })
        .catch(error => {
          log.error('[ERROR] Fail to delete modality')
          log.error(error)
          reject(error.response)
        })
    })
  }
}
